import React from 'react';
import styled, { css } from 'styled-components';
import { layout, styledUtils } from '@prisjakt/ui-base';

const { spacingNormal } = layout.measurements;

type StyledProps = { height: string; background: boolean };

const Images = styled.div<StyledProps>`
  display: grid;
  grid-auto-flow: column;
  column-gap: ${spacingNormal};
  position: relative;
  padding: 0 ${spacingNormal};
  align-items: center;
  width: 100%;
  height: ${p => p.height};

  img {
    max-height: 64px;
  }

  ${p =>
    p.background &&
    css`
      &::after {
        ${styledUtils.overlay()};
        pointer-events: none;
      }
    `}
`;

type Props = {
  products: {
    name: string;
    image?: string | null;
    media?: {
      first?: string;
    };
    order: number;
  }[];
  selectedPosition?: number;
  height?: string;
  background?: boolean;
};

function ProductImages({
  products,
  selectedPosition = 1,
  height = 'auto',
  background = true,
}: Props) {
  // Select the two closest product images to the selected product
  const visible = 3;
  const productImages = products
    .filter(item => {
      if (selectedPosition === 1) return item.order <= visible;
      if (selectedPosition === products.length)
        return item.order > products.length - visible;

      return (
        item.order === selectedPosition - 1 ||
        item.order === selectedPosition ||
        item.order === selectedPosition + 1
      );
    })
    .map(
      p =>
        (p.image || p.media?.first) && (
          <img
            alt={p.name}
            key={p.image || p.media?.first}
            src={p.image || p.media?.first}
          />
        )
    );

  return (
    <Images background={background} height={height}>
      {productImages}
    </Images>
  );
}

export default ProductImages;
